import * as Yup from "yup";
import { forceInt } from "Utils";

export const AuthorValidationSchema = Yup.object().shape({});

export const AuthorObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    name: null,
    slug: null,
    status: null,
    email: null,
    description: null,
    description_raw: null,
    tagline: null,
    metadata: null,
    created_at: null,
    modified_at: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let author = Object.assign({}, AuthorObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        name: requestData.name,
        slug: requestData.slug,
        email: requestData.email,
        status: requestData.status,
        description: requestData.description,
        description_raw: requestData.description_raw,
        tagline: requestData.tagline,
        metadata: requestData.metadata,
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
    });

    return author;
}
